const spotlights = [
  {
    tag: '热播剧集',
    title: '2026 夏季档高分剧集盘点',
    desc: '各大平台夏季新剧陆续上线，我们精选了豆瓣评分 8.0 以上的热门剧集，从悬疑烧脑到温情治愈，总有一部适合你的夏夜时光。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20of%20popular%20TV%20drama%20series%20collage%2C%20soft%20golden%20lighting%2C%20elegant%20film%20reel%20texture%2C%20dramatic%20mood%2C%20warm%20amber%20and%20brown%20tones%2C%20cinematic%20atmosphere%2C%20rich%20theater%20aesthetic%2C%20no%20text%2C%20artistic%20composition&width=800&height=450&seq=spotlight-1&orientation=landscape',
  },
  {
    tag: '院线大片',
    title: '暑期档必看院线新片速览',
    desc: '动作、科幻、喜剧、动画……暑期档类型全面开花。我们为你整理本月最值得期待的院线新片，提前锁定观影清单。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20golden%20spotlight%2C%20grand%20screen%2C%20plush%20red%20seats%2C%20elegant%20film%20atmosphere%2C%20luxurious%20cinema%20aesthetic%2C%20soft%20amber%20lighting%2C%20dramatic%20composition%2C%20no%20text%2C%20artistic%20style&width=800&height=450&seq=spotlight-2&orientation=landscape',
  },
  {
    tag: '经典回顾',
    title: '那些年我们追过的经典港片',
    desc: '从武侠到警匪，从喜剧到爱情，香港电影的黄金年代留下了无数经典。重温那些熟悉的面孔和难忘的台词，感受港片独有的魅力。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20film%20aesthetic%20with%20vintage%20movie%20posters%2C%20old%20cinema%20marquee%20lights%2C%20warm%20sepia%20tones%2C%20retro%20film%20atmosphere%2C%20golden%20hour%20lighting%2C%20elegant%20nostalgia%2C%20rich%20texture%2C%20no%20text%2C%20artistic%20composition&width=800&height=450&seq=spotlight-3&orientation=landscape',
  },
  {
    tag: '独家专题',
    title: '女性导演作品精选特辑',
    desc: '越来越多的女性导演在国际影坛崭露头角，她们以独特视角讲述动人故事。本期特辑精选十部不容错过的女性导演佳作。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20artistic%20film%20director%20scene%20with%20warm%20cinematic%20lighting%2C%20director%20chair%20on%20set%2C%20soft%20golden%20backlight%2C%20creative%20filmmaking%20atmosphere%2C%20rich%20amber%20tones%2C%20sophisticated%20aesthetic%2C%20no%20text%2C%20clean%20composition&width=800&height=450&seq=spotlight-4&orientation=landscape',
  },
  {
    tag: '新片速递',
    title: '本周最受期待新片上线',
    desc: '多部备受瞩目的新片本周陆续登陆平台，涵盖国内外口碑力作。立即查看完整片单，锁定你的周末观影计划。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20premiere%20atmosphere%20with%20elegant%20red%20carpet%2C%20golden%20spotlights%2C%20luxurious%20theater%20entrance%2C%20warm%20amber%20toned%20lighting%2C%20dramatic%20cinema%20aesthetic%2C%20sophisticated%20mood%2C%20no%20text%2C%20artistic%20style&width=800&height=450&seq=spotlight-5&orientation=landscape',
  },
];

export default function SpotlightSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选热门影视专题，深度解读与推荐，发现更多值得看的好内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {spotlights.slice(0, 2).map((item, idx) => (
            <article
              key={idx}
              className="lg:col-span-2 bg-background-50 rounded-lg overflow-hidden flex flex-col md:flex-row group cursor-pointer"
            >
              <div className="md:w-[55%] aspect-[16/9] md:aspect-auto overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="md:w-[45%] p-5 md:p-6 flex flex-col justify-center">
                <span className="text-xs font-medium text-accent-500 bg-accent-100/70 self-start px-2.5 py-1 rounded-full mb-3">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}

          {spotlights.slice(2).map((item, idx) => (
            <article
              key={idx + 2}
              className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs font-medium text-accent-500 bg-accent-100/70 self-start px-2.5 py-1 rounded-full mb-3 inline-block">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}